/**
 * Farnsworth Labs was founded by Dr. Hubert Farnsworth for the purpose of advancing science.
 * 
 * This module is responsible for setting up and executing different tests within Songbirds code base. Tests can be
 * anything we want to try on a subset of of users and track how well it worked. This allows us to try new alogorithms
 * without impacting all traffic.
 */
var cache = require('../models/cache'),
  CONST_EVENTS = require('../constants/events'),
  activeEvents = require('../events/eventObserver').active,
  generalUtility = require('../utilities/generalUtility'),
  log = require('./logger').getLoggerInstance('Base.FarnsworthLabs');

var privateMethods = {
    /**
     * Generates a random number from 0 to a number. This can be used to pick a test group.
     * @param {Number} max The max allowed value to include in the random number. This values is exclusive.
     */
    generateRandomInRange: function (max) {
      return Math.floor(Math.random() * max);
    }
  },
  publicMethods = {
    /**
     * Setup the all active experiments
     */
    init: function () {
      cache.tid = generalUtility.getTid();
      log.debug('Setting session Tid to: ' + cache.tid);

      log.debug('Setting up test groups');
      publicMethods.pickTestGroup('CorsRetry', 2);
    },
    /**
     * Helper to setup an experiement. It will pick a random test group and store the group number in the cache object.
     * @param {String} nameOfTest The key that should be used to store the test group in cache
     * @param {Number} numberOfTestGroups How many test groups should be used when picking a random test group. Groups picked start from 0
     */  
    pickTestGroup: function (nameOfTest, numberOfTestGroups) {
      var testGroup = privateMethods.generateRandomInRange(numberOfTestGroups);

      log.debug('Selected group [' + testGroup + '] for experiment [' + nameOfTest + '] ')
      cache.farnsworthLabs[nameOfTest] = testGroup;
    },
    /**
     * A configuration method that is bound to a public API. This allows us to override test groups with code
     * @param {{testGroup: string, numberOfGroups: number}} configurationData The 
     */
    configureTestGroup: function (configurationData) {
      if (cache.farnsworthLabs[configurationData.testGroup] !== undefined) {
        log.debug('Event override detected for test group [' + configurationData.testGroup + '], forcing test group to [' + configurationData.groupNumber + ']');
        cache.farnsworthLabs[configurationData.testGroup] = configurationData.groupNumber;
      }
    }
  };

activeEvents.subscribe(CONST_EVENTS.FARNSWORTH_GIVE_NEWS, publicMethods.configureTestGroup);

module.exports = publicMethods;


//////////////////
// WEBPACK FOOTER
// ./libraries/farnsworthLabs.js
// module id = 112
// module chunks = 5